import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Works from './pages/Works';
import About from './pages/About';
import AcademicPage_1_TVCG from './pages/AcademicPage_1_TVCG';
import AcademicPage_2_ISMAR from './pages/AcademicPage_2_ISMAR';
import AcademicPage_3_CHI_LBW from './pages/AcademicPage_3_CHI_LBW';
import AcademicPage_4_AAMAS from './pages/AcademicPage_4_AAMAS';
import ComingSoon from './pages/ComingSoon';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/works" element={<Works />} />
          <Route path="/about" element={<About />} />
          <Route path="/academic/AcademicPage_1_TVCG" element={<AcademicPage_1_TVCG />} />
          <Route path="/academic/AcademicPage_2_ISMAR" element={<AcademicPage_2_ISMAR />} />
          <Route path="/academic/AcademicPage_3_CHI_LBW" element={<AcademicPage_3_CHI_LBW />} />
          <Route path="/academic/AcademicPage_4_AAMAS" element={<AcademicPage_4_AAMAS />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
